<template>
  <section class="news">
    <heading
      v-bind="{label, title, subtitle}"
      level="h2"
    />
    <div class="news__list">
      <Thumbnail v-for="(item, index) in collectionItems" :key="index" v-bind="item" />
    </div>
    <Buttons v-if="buttons" :buttons="buttons" />
  </section>
</template>

<script>
import Heading from '@/components/heading/Heading.vue'
import Thumbnail from '@/components/partials/Thumbnail.vue'
import Buttons from '@/components/buttons/Buttons'
import NewsApiService from '@/data/news/NewsApiService'
import dayjs from 'dayjs'
import collectionApiService from '@/data/collection/CollectionApiService'

export default {
  components: {
    Thumbnail,
    Heading,
    Buttons
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    collection: {
      type: [Object, Boolean],
      default: false
    },
    subtitle: {
      type: String,
      default: ''
    },
    number_of_items: {
      type: Number,
      default: 3
    },
    buttons: {
      type: Array,
      default: () => {}
    },
    loadOnInit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    let placeholders = []
    for (let i = 0; i < this.numberOfItems; i++) {
      placeholders.push({
        label: '...',
        title: '...',
        image: {
          url: 'https://picsum.photos/200/300'
        }
      })
    }
    return {
      collectionItems: placeholders
    }
  },
  methods: {
    parseLabel (item) {
      if (item.start_date) {
        return dayjs(item.start_date).format('DD MMMM YYYY')
      }
      return null
    }
  },
  async mounted () {
    if (!this.loadOnInit) {
      return
    }
    if (!this.collection) {
      console.log('No collection on the listing provided')
      return false
    }
    if (!this.collection.handle) {
      console.log('No handle param on the collection object on the listing provided')
      return false
    }
    const response = await collectionApiService.indexByTree(this.collection.handle)
    let newsItems = response.data.map(i => ({
      image: i.image,
      title: i.title,
      link: i.url,
      label: this.parseLabel(i)
    }))
    if(newsItems) {
      this.collectionItems = this.number_of_items ? newsItems.slice(0, this.number_of_items) : newsItems
    }
  }
}
</script>

<style lang="scss">
.news {
  &__list {
    padding: $padding;
  }
  &__button {
    margin-top: rem(10);
  }
}
</style>


<docs>
  ```vue
    <section-news
        title="Just 2 previews"
        :show-button="false"
        :number-of-items="2"
        :load-on-init="false"
    />
  ```
  ```vue
    <section-news
        title="THIS WEEK'S News"
        :show-button="true"
        :number-of-items="10"
        button-text="READ ALL NEW NOW"
        :load-on-init="false"
    />
  ```
</docs>
